import React from "react";

const styles = {
    pending: "bg-amber-50 text-amber-800 border-amber-200",
    verified: "bg-emerald-50 text-emerald-800 border-emerald-200",
    rejected: "bg-rose-50 text-rose-800 border-rose-200",
    matched: "bg-blue-50 text-blue-800 border-blue-200",
    active: "bg-emerald-50 text-emerald-800 border-emerald-200",
    inactive: "bg-slate-100 text-slate-600 border-slate-200",
};

export default function StatusBadge({ status, className = "" }) {
    const s = (status || "").toLowerCase();
    const cls = styles[s] || "bg-slate-100 text-slate-700 border-slate-200";
    return (
        <span
            data-testid={`status-badge-${s}`}
            className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize ${cls} ${className}`}
        >
            {status}
        </span>
    );
}
